module.exports = __webpack_public_path__ + "assets/img/1921591928118_.pic_hd.356c23a7.jpg";